import styled from "styled-components";

export const FilterWrapper = styled.div`
    /* width: 400px; */
    height: 100vh;
    margin: 0px 15px;
    /* border-radius: 15px; */
    z-index: 9999999;
    font-family: "SF-Pro"!important;
`;

export const AccordionWrapper = styled.div`
  width: 350px;
  height: 100vh;
  position: sticky;
  padding: 10px;
  background-color: #fff;
  top: 0px;
  font-family: "SF-Pro"!important;
  .btn_filter_wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 20px;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e4e4e4;

    .btn_filter {
      display: inline;
      flex: 1;
      background-color: #9cc54b;
      color: #fff;
    }
    .clear_filter_btn {
      background: #4a4a49;
    }
  }
  @media (max-width: 600px) {
      width: 350px;
  }
  @media (min-width: 800px) {
      width: 400px;
  }

  @media (min-width: 1020px) {
      width: 400px;
  }
  @media (min-width: 1280px) {
      width: 400px;
  }
  @media (min-width: 1920px) {
      width: 500px;
  }
  /* margin: 0 10px; */
  .close{
    font-weight: bold;
    cursor: pointer;
    &:hover{
      color: red;
    }
  }
  /* overflow: scroll; */
  .body {
    height: 80%;
    padding: 0 8px;
    overflow-y: auto;
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 20px;

    }

    /* Color for the scrollbar thumb */
    ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 20px;
    }

    /* Color on hover for the scrollbar thumb */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    width: 100%;
    display: flex;
    flex-direction: column;
    /* background-color: red; */
  }
  .range-input-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.range-input {
  width: 100%;
  margin-right: 1rem;
  -webkit-appearance: none;
  height: 6px;
  border-radius: 6px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.range-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  /* color: rgb(156, 197, 75); */
  background: rgb(156, 197, 75);
  cursor: pointer;

}

.range-input::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(156, 197, 75);
  cursor: pointer;
}

.range-value-container {
  display: flex;
  text-align: center;
  justify-content: space-between;
  align-items: center;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

/* .range-min,
.range-max {
  font-weight: bold;
}

.range-value {
  padding: 0 0.5rem;
  background-color: #4CAF50;
  color: white;
  border-radius: 5px;
  margin: 0 5px;
  width: 50px;
  max-width: 50px;
} */

`;
export const AccordionContainer = styled.div`
  /* border: 1px solid #e6e6e6; */
  // border-radius: 5px;
  // margin-bottom: 10px;
  /* box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1); */
  border-bottom: 1px solid #e4e4e4;
  font-family: "SF-Pro"!important;
  /* overflow: hidden; */
  /* overflow-y: auto; */

  &:last-child {
    border: none;
  }
`;

export const AccordionHeader = styled.div`
  align-items: center;
  /* background-color: #f5f5f5; */
  color: rgb(156, 197, 75);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 700;
  padding: 12px 8px;
  position: relative;
  font-family: "SF-Pro"!important;

  &::after {
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    transition: transform 0.3s ease;
  }

  .react-switch {
    &.active {
      .react-switch-bg {
        background: #9cc54b !important;
      }
    }
  }

  ${({ isOpen }) =>
        isOpen &&
        `
    &::after {
      transform: translateY(-50%) rotate(180deg);
    }
  `}
`;

export const AccordionTitle = styled.h6`
  margin: 0;
  font-size: 20px !important;
  font-family: "SF-Pro"!important;
  font-weight: 500;
  @media (min-width: 800px) {
    font-size: 22px;
  }
`;

export const AccordionIcon = styled.div`
  font-size: 20px;
`;

export const AccordionContent = styled.div`
  padding: 0 8px 20px 8px;
  font-family: "SF-Pro"!important;
  .list_item{
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .form-group {
    margin-bottom: 0;
  }
  .item{
    width: fit-content;
    display: flex;
    justify-content: space-between;
    // margin: 0 5px;
    transition: all 0.2s ease;

    &:hover {
      font-weight: 600; 
    }

    .form-check {
      gap: 10px;

      .form-check-input {
        width: 1rem;
        height: 1rem;
        margin-right: 0;
        cursor: pointer;
      }
  
      .form-check-label {
        cursor: pointer;
      }
    }
  }
  .item_value {
    background-color: rgb(156, 197, 75);
    padding: 2px 5px;
    font-size: 12px;
    border-radius: 5px;
    color: #FFF;
  }

  .react-switch {
    &.active {
      .react-switch-bg {
        background: #9cc54b !important;
      }
    }
  }
`;

export const SeeMoreButton = styled.div`
  .see-more {
    text-decoration: none;
    font-size: 16px;
    font-weight: 400;
    color: #9cc54b;

    &:hover {
      cursor: pointer;
    }}
  }
`;